import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useGetBuildingsQuery } from '../../../services/organizations/organizations.service';
import { GridReadyEvent } from 'ag-grid-community';
import { updateGridModels } from '../../../store/grids';
import { RootState } from '../../../store';
import SettingsContext from '../../../contexts/settings.context';
import { useGetTermSetQuery } from '../../../services/i18n/i18n.service';
import { PLATFORM_DEFS } from '../../../constants/i18n/translations/termSetDefinitions/platform';
import { skipToken } from '@reduxjs/toolkit/query';

const useBuildingsGrid = () => {
    const dispatch = useDispatch();
    const { administration } = useSelector((state: RootState) => state.grids);
    const navigate = useNavigate();
    const [gridApi, setGridApi] = useState(null);
    const { data: rowData, isLoading: isLoading } = useGetBuildingsQuery();
    const [gridColumnApi, setGridColumnApi] = useState(null);

    const { settings } = useContext(SettingsContext);
    const { data: termSet } = useGetTermSetQuery(
        settings?.userSettings
            ? {
                  languageId: settings?.userSettings?.languageId,
                  code: PLATFORM_DEFS.BUILDINGS_GRID,
              }
            : skipToken
    );
    const onGridReady = (params: GridReadyEvent) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const redirectToForm = (row: any) => {
        if (row.id) {
            navigate(`/administration/organizations/buildings/${row.id}`);
        } else {
            navigate('/administration/organizations/buildings/new');
        }
    };

    const onFirstDataRendered = () => {
        gridColumnApi?.applyColumnState({
            state: administration.buildingsList.column,
            applyOrder: true,
        });

        gridApi?.setFilterModel(administration.buildingsList.filter);
    };

    const onSortChanged = () => {
        dispatch(
            updateGridModels({
                gridLocation: 'administration',
                gridName: 'buildingsList',
                type: 'column',
                model: gridColumnApi.getColumnState(),
            })
        );
    };

    const onFilterChanged = (e: any) => {
        e.preventDefault();
        dispatch(
            updateGridModels({
                gridLocation: 'administration',
                gridName: 'buildingsList',
                type: 'filter',
                model: gridApi.getFilterModel(),
            })
        );
    };

    return {
        onGridReady,
        rowData,
        isLoading,
        redirectToForm,
        onSortChanged,
        onFilterChanged,
        onFirstDataRendered,
        termSet,
    };
};

export default useBuildingsGrid;
